<ng-container *ngIf="(accessToken$ | async) as accessToken">
  <awair-create-organization-form [errorMessage]="errorMessage$ | async"
                                  [isOrganizationCreating]="isOrganizationCreating$ | async"
                                  [isOrganizationCreated]="isOrganizationCreated$ | async"
                                  (createOrganization)="onCreateOrganization($event, accessToken)"
                                  (cancel)="onCancel()">
  </awair-create-organization-form>
</ng-container>
